import { useContext } from 'react';
import {
    FreelancerPageContext,
    FreelancerPageContextProvider,
    FreelancerPageContextProps,
} from './FreelancerPageContext';

const useFreelancerPageContext = () => useContext(FreelancerPageContext);

export { useFreelancerPageContext, FreelancerPageContextProvider, FreelancerPageContextProps };
